<fgb-page-header [pageTitle]="'trivia.page.title'" [backButtonLink]="'/games'" class="short-footer" />

<div class="games-container">
  <div class="container d-flex flex-column">
    <a class="back-btn pt-lg-0 text-white d-none d-lg-flex flex-row align-items-center fw-bold" [routerLink]="'/games'"
      ><span class="material-symbols-outlined"> keyboard_arrow_left </span>
      <span class="font-size-14">{{ 'fantasy.back.to.game' | translate }}</span></a
    >
    <img class="banner-img" [src]="'games/trivia-banner.jpg' | contentAssetImage" alt="trivia banner" />
  </div>
</div>

<div class="games-page">
  <fgb-leaderboard-nav routeLink="trivia"></fgb-leaderboard-nav>
  <div class="games-content-area">
    <router-outlet></router-outlet>
  </div>
</div>
